const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyCash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 11.263978,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(80.000001%,80.000001%,80.000001%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 1.299997 207.799591 L 1.299997 431.099152 L 511.998993 431.099152 L 511.998993 207.799591 Z M 17.099966 415.299183 L 17.099966 223.49956 L 496.199024 223.49956 L 496.199024 415.299183 Z M 17.099966 415.299183 ",
    transform: "matrix(0.0390626,0,0,0.0390626,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 11.263978,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(80.000001%,80.000001%,80.000001%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 256.699495 255.599497 C 221.499564 255.599497 192.899621 284.299441 192.899621 319.399372 C 192.899621 354.599303 221.499564 383.199246 256.699495 383.199246 C 291.799426 383.199246 320.39937 354.599303 320.39937 319.399372 C 320.39937 284.299441 291.799426 255.599497 256.699495 255.599497 Z M 256.699495 367.399277 C 230.199547 367.399277 208.699589 345.89932 208.699589 319.399372 C 208.699589 292.999424 230.199547 271.399466 256.699495 271.399466 C 283.099443 271.399466 304.699401 292.999424 304.699401 319.399372 C 304.699401 345.89932 283.099443 367.399277 256.699495 367.399277 Z M 256.699495 367.399277 ",
    transform: "matrix(0.0390626,0,0,0.0390626,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 11.263978,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(80.000001%,80.000001%,80.000001%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 488.09904 231.699544 L 25.29995 231.699544 L 25.29995 407.099199 L 488.09904 407.099199 Z M 41.099919 391.29923 L 41.099919 354.899302 C 49.499903 362.499287 60.79988 367.199278 73.099856 367.199278 C 99.399804 367.199278 120.899762 345.79932 120.899762 319.399372 C 120.899762 293.099423 99.399804 271.599466 73.099856 271.599466 C 60.79988 271.599466 49.499903 276.299457 41.099919 283.999441 L 41.099919 247.499513 L 206.599594 247.499513 C 185.699635 262.099484 171.399663 285.499438 169.299667 312.399386 L 129.399745 312.399386 L 129.399745 328.099355 L 169.399667 328.099355 C 171.999662 354.299303 186.099634 376.999258 206.599594 391.29923 Z M 41.099919 319.399372 C 41.099919 301.799406 55.399891 287.399435 73.099856 287.399435 C 90.699822 287.399435 105.099793 301.799406 105.099793 319.399372 C 105.099793 337.099337 90.699822 351.399309 73.099856 351.399309 C 55.399891 351.399309 41.099919 337.099337 41.099919 319.399372 Z M 184.699637 319.399372 C 184.699637 279.69945 216.999573 247.499513 256.699495 247.499513 C 296.299417 247.499513 328.599354 279.69945 328.599354 319.399372 C 328.599354 359.099294 296.299417 391.29923 256.699495 391.29923 C 216.999573 391.29923 184.699637 359.099294 184.699637 319.399372 Z M 472.299071 283.999441 C 463.799088 276.299457 452.59911 271.599466 440.299134 271.599466 C 413.899186 271.599466 392.499228 293.099423 392.499228 319.399372 C 392.499228 345.79932 413.899186 367.199278 440.299134 367.199278 C 452.59911 367.199278 463.799088 362.499287 472.299071 354.899302 L 472.299071 391.29923 L 306.799397 391.29923 C 327.199356 376.999258 341.299329 354.299303 343.899324 328.099355 L 383.999245 328.099355 L 383.999245 312.399386 L 344.099323 312.399386 C 341.899327 285.499438 327.699355 262.099484 306.799397 247.499513 L 472.299071 247.499513 Z M 472.299071 319.399372 C 472.299071 337.099337 457.899099 351.399309 440.299134 351.399309 C 422.599169 351.399309 408.199197 337.099337 408.199197 319.399372 C 408.199197 301.799406 422.599169 287.399435 440.299134 287.399435 C 457.899099 287.399435 472.299071 301.799406 472.299071 319.399372 Z M 472.299071 319.399372 ",
    transform: "matrix(0.0390626,0,0,0.0390626,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 11.263978,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(80.000001%,80.000001%,80.000001%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 260.899487 313.999382 C 252.799503 310.699389 249.29951 308.499393 249.29951 304.599401 C 249.29951 301.299407 251.699505 297.899414 258.399492 297.899414 C 264.899479 297.899414 269.19947 300.09941 271.499466 301.099408 L 273.999461 292.299425 C 270.999467 290.799428 266.899475 289.399431 260.799487 289.199431 L 260.799487 280.299449 L 252.999502 280.299449 L 252.999502 289.59943 C 243.299521 291.399427 237.599533 297.699414 237.599533 305.899398 C 237.599533 314.799381 244.09952 319.399372 254.0995 322.999365 C 261.199486 325.59936 264.59948 328.399354 264.59948 332.699346 C 264.59948 337.299337 260.499488 340.299331 254.3995 340.299331 C 248.599511 340.299331 243.199522 338.299335 239.499529 336.099339 L 236.899534 345.099321 C 240.299527 347.399317 246.399515 349.099313 252.399504 349.299313 L 252.399504 358.599295 L 260.299488 358.599295 L 260.299488 348.699314 C 270.799467 346.999317 276.399456 339.799332 276.399456 331.699348 C 276.399456 323.099364 271.699466 317.999375 260.899487 313.999382 Z M 260.899487 313.999382 ",
    transform: "matrix(0.0390626,0,0,0.0390626,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 11.263978,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(80.000001%,80.000001%,80.000001%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 65.199872 312.399386 L 80.999841 312.399386 L 80.999841 328.099355 L 65.199872 328.099355 Z M 65.199872 312.399386 ",
    transform: "matrix(0.0390626,0,0,0.0390626,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 11.263978,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(80.000001%,80.000001%,80.000001%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 432.29915 312.399386 L 448.099119 312.399386 L 448.099119 328.099355 L 432.29915 328.099355 Z M 432.29915 312.399386 ",
    transform: "matrix(0.0390626,0,0,0.0390626,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 11.263978,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(80.000001%,80.000001%,80.000001%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 0 176.699652 L 0 199.799607 L 15.799969 199.799607 L 15.799969 192.399622 L 495.499025 192.399622 L 495.499025 199.799607 L 511.198994 199.799607 L 511.198994 176.699652 Z M 0 176.699652 ",
    transform: "matrix(0.0390626,0,0,0.0390626,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 11.263978,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(80.000001%,80.000001%,80.000001%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 0 145.099715 L 0 168.199669 L 15.799969 168.199669 L 15.799969 160.899684 L 495.499025 160.899684 L 495.499025 168.199669 L 511.198994 168.199669 L 511.198994 145.099715 Z M 0 145.099715 ",
    transform: "matrix(0.0390626,0,0,0.0390626,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 11.263978,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(80.000001%,80.000001%,80.000001%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 0 113.499777 L 0 135.599733 L 15.799969 135.599733 L 15.799969 129.299746 L 495.499025 129.299746 L 495.499025 135.599733 L 511.198994 135.599733 L 511.198994 113.499777 Z M 0 113.499777 ",
    transform: "matrix(0.0390626,0,0,0.0390626,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 11.263978,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(80.000001%,80.000001%,80.000001%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 0 80.899841 L 0 104.099795 L 15.799969 104.099795 L 15.799969 96.69981 L 495.499025 96.69981 L 495.499025 104.099795 L 511.198994 104.099795 L 511.198994 80.899841 Z M 0 80.899841 ",
    transform: "matrix(0.0390626,0,0,0.0390626,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 1.299997 207.799591 L 1.299997 431.099152 L 511.998993 431.099152 L 511.998993 207.799591 Z M 17.099966 415.299183 L 17.099966 223.49956 L 496.199024 223.49956 L 496.199024 415.299183 Z M 17.099966 415.299183 ",
    transform: "matrix(0.0390626,0,0,0.0390626,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 256.699495 255.599497 C 221.499564 255.599497 192.899621 284.299441 192.899621 319.399372 C 192.899621 354.599303 221.499564 383.199246 256.699495 383.199246 C 291.799426 383.199246 320.39937 354.599303 320.39937 319.399372 C 320.39937 284.299441 291.799426 255.599497 256.699495 255.599497 Z M 256.699495 367.399277 C 230.199547 367.399277 208.699589 345.89932 208.699589 319.399372 C 208.699589 292.999424 230.199547 271.399466 256.699495 271.399466 C 283.099443 271.399466 304.699401 292.999424 304.699401 319.399372 C 304.699401 345.89932 283.099443 367.399277 256.699495 367.399277 Z M 256.699495 367.399277 ",
    transform: "matrix(0.0390626,0,0,0.0390626,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 488.09904 231.699544 L 25.29995 231.699544 L 25.29995 407.099199 L 488.09904 407.099199 Z M 41.099919 391.29923 L 41.099919 354.899302 C 49.499903 362.499287 60.79988 367.199278 73.099856 367.199278 C 99.399804 367.199278 120.899762 345.79932 120.899762 319.399372 C 120.899762 293.099423 99.399804 271.599466 73.099856 271.599466 C 60.79988 271.599466 49.499903 276.299457 41.099919 283.999441 L 41.099919 247.499513 L 206.599594 247.499513 C 185.699635 262.099484 171.399663 285.499438 169.299667 312.399386 L 129.399745 312.399386 L 129.399745 328.099355 L 169.399667 328.099355 C 171.999662 354.299303 186.099634 376.999258 206.599594 391.29923 Z M 41.099919 319.399372 C 41.099919 301.799406 55.399891 287.399435 73.099856 287.399435 C 90.699822 287.399435 105.099793 301.799406 105.099793 319.399372 C 105.099793 337.099337 90.699822 351.399309 73.099856 351.399309 C 55.399891 351.399309 41.099919 337.099337 41.099919 319.399372 Z M 184.699637 319.399372 C 184.699637 279.69945 216.999573 247.499513 256.699495 247.499513 C 296.299417 247.499513 328.599354 279.69945 328.599354 319.399372 C 328.599354 359.099294 296.299417 391.29923 256.699495 391.29923 C 216.999573 391.29923 184.699637 359.099294 184.699637 319.399372 Z M 472.299071 283.999441 C 463.799088 276.299457 452.59911 271.599466 440.299134 271.599466 C 413.899186 271.599466 392.499228 293.099423 392.499228 319.399372 C 392.499228 345.79932 413.899186 367.199278 440.299134 367.199278 C 452.59911 367.199278 463.799088 362.499287 472.299071 354.899302 L 472.299071 391.29923 L 306.799397 391.29923 C 327.199356 376.999258 341.299329 354.299303 343.899324 328.099355 L 383.999245 328.099355 L 383.999245 312.399386 L 344.099323 312.399386 C 341.899327 285.499438 327.699355 262.099484 306.799397 247.499513 L 472.299071 247.499513 Z M 472.299071 319.399372 C 472.299071 337.099337 457.899099 351.399309 440.299134 351.399309 C 422.599169 351.399309 408.199197 337.099337 408.199197 319.399372 C 408.199197 301.799406 422.599169 287.399435 440.299134 287.399435 C 457.899099 287.399435 472.299071 301.799406 472.299071 319.399372 Z M 472.299071 319.399372 ",
    transform: "matrix(0.0390626,0,0,0.0390626,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 260.899487 313.999382 C 252.799503 310.699389 249.29951 308.499393 249.29951 304.599401 C 249.29951 301.299407 251.699505 297.899414 258.399492 297.899414 C 264.899479 297.899414 269.19947 300.09941 271.499466 301.099408 L 273.999461 292.299425 C 270.999467 290.799428 266.899475 289.399431 260.799487 289.199431 L 260.799487 280.299449 L 252.999502 280.299449 L 252.999502 289.59943 C 243.299521 291.399427 237.599533 297.699414 237.599533 305.899398 C 237.599533 314.799381 244.09952 319.399372 254.0995 322.999365 C 261.199486 325.59936 264.59948 328.399354 264.59948 332.699346 C 264.59948 337.299337 260.499488 340.299331 254.3995 340.299331 C 248.599511 340.299331 243.199522 338.299335 239.499529 336.099339 L 236.899534 345.099321 C 240.299527 347.399317 246.399515 349.099313 252.399504 349.299313 L 252.399504 358.599295 L 260.299488 358.599295 L 260.299488 348.699314 C 270.799467 346.999317 276.399456 339.799332 276.399456 331.699348 C 276.399456 323.099364 271.699466 317.999375 260.899487 313.999382 Z M 260.899487 313.999382 ",
    transform: "matrix(0.0390626,0,0,0.0390626,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 65.199872 312.399386 L 80.999841 312.399386 L 80.999841 328.099355 L 65.199872 328.099355 Z M 65.199872 312.399386 ",
    transform: "matrix(0.0390626,0,0,0.0390626,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 432.29915 312.399386 L 448.099119 312.399386 L 448.099119 328.099355 L 432.29915 328.099355 Z M 432.29915 312.399386 ",
    transform: "matrix(0.0390626,0,0,0.0390626,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 0 176.699652 L 0 199.799607 L 15.799969 199.799607 L 15.799969 192.399622 L 495.499025 192.399622 L 495.499025 199.799607 L 511.198994 199.799607 L 511.198994 176.699652 Z M 0 176.699652 ",
    transform: "matrix(0.0390626,0,0,0.0390626,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 0 145.099715 L 0 168.199669 L 15.799969 168.199669 L 15.799969 160.899684 L 495.499025 160.899684 L 495.499025 168.199669 L 511.198994 168.199669 L 511.198994 145.099715 Z M 0 145.099715 ",
    transform: "matrix(0.0390626,0,0,0.0390626,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 0 113.499777 L 0 135.599733 L 15.799969 135.599733 L 15.799969 129.299746 L 495.499025 129.299746 L 495.499025 135.599733 L 511.198994 135.599733 L 511.198994 113.499777 Z M 0 113.499777 ",
    transform: "matrix(0.0390626,0,0,0.0390626,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 0 80.899841 L 0 104.099795 L 15.799969 104.099795 L 15.799969 96.69981 L 495.499025 96.69981 L 495.499025 104.099795 L 511.198994 104.099795 L 511.198994 80.899841 Z M 0 80.899841 ",
    transform: "matrix(0.0390626,0,0,0.0390626,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyCash);
export default __webpack_public_path__ + "static/media/money-cash.5b78c7dc2e3379463a3b249079fad3ff.svg";
export { ForwardRef as ReactComponent };